<template>
  <div class="technical-support-page">
      <fancy-header></fancy-header>
      <div class="container">
          <div class="row">
              <div class="col-md-3 col-sm-3 col-xs-12 p-text">
                  <div class="col-xs-12">
                    <div>
                      <p>عند استلام طلبك حول الدعم الفني المطلوب, سيتم معالجته في أسرع وقت ممكن. </p>
                  </div>
                  <div>
                      <p>يرجى تزويدنا برقم هاتف وبريد الكتروني متاح للتواصل معك مباشرةً.</p>
                  </div>
                  </div>
                  
              </div>
              <div class="col-md-9 col-sm-9 col-xs-12">
                 <ticket></ticket>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
import Ticket from '@/components/technical support/ticket'
import FancyHeader from '@/components/shared/fancy-header'
export default {
    name:'TechnicalSupport',
    components:{
        Ticket,
        FancyHeader
    }
  
}
</script>
<style lang="scss">
  @import "src/assets/sass/shared.scss";
    .technical-support-page{
        & > .container{
            margin-top:30px;
            margin-bottom:30px;
            direction:$dir; 
            .p-text{
                padding:10px;

                & > div{
                    margin-top:10p;
                    p{
                        direction:$dir;
                        font-size:16px;
                        color:$p-color;
                        @include text-align($dir);
                    }
                }

            }
          
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/technical support/index.vue